import { useTranslation } from 'react-i18next';

import { SummaryInformation, TSummaryInformation } from '@/ui-kit/SummaryInformation/SummaryInformation';

import { IUser } from '@/features/user/store/user.model';

import { useBusinessUserVerificationProps } from '@/features/kyc/hooks/useBusinessUserVerificationProps';
import { TaxResidences } from '@/features/taxResidences/components/TaxResidences';

import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';
import { TBusinessSectionKey } from '@/features/kyc/store/types/business.types';

interface IMainInformation {
  user: IUser;
  isSectionOnEdition: (key: TBusinessSectionKey) => boolean;
  isSectionEditable: (key: TBusinessSectionKey) => boolean;
  toogleSectionEditMode: (key: TBusinessSectionKey) => void;
}

export function BusinessVerificationDetail({
  user,
  isSectionOnEdition,
  isSectionEditable,
  toogleSectionEditMode,
}: IMainInformation) {
  const { t } = useTranslation();

  const isSituationOnEdition = isSectionOnEdition('situation');

  const { situation, isLoading, onUpdateUser, onCancelEdition } = useBusinessUserVerificationProps({
    user,
    isSituationOnEdition,
  });

  const userVerification: TSummaryInformation = {
    title: t('pages.dashboard.createUser.form.pages.verificationDetails'),
    sections: [
      {
        component: (
          <KycInformationSection
            section={situation}
            isOnEdition={isSituationOnEdition}
            sectionKey="situation"
            isLoading={isLoading}
            isSectionNotEditable={isSectionEditable('situation')}
            onEdit={() => toogleSectionEditMode('situation')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('situation'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('situation'))}
          />
        ),
      },
      {
        component: (
          <TaxResidences
            user={user}
            isSectionOnEdition={isSectionOnEdition('taxResidence')}
            isSectionEditable={isSectionEditable('taxResidence')}
            toogleSectionEditMode={() => toogleSectionEditMode('taxResidence')}
          />
        ),
      },
    ],
  };
  return <SummaryInformation {...userVerification} />;
}
